"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var StyledWrapper = _styledComponents.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  position: relative;\n  width: 40px;\n  display: flex;\n\n  transform: translateX(", ")\n    rotate(", ");\n"])), function (p) {
  return p.isClaimed ? "9px" : 0;
}, function (p) {
  return p.isClaimed ? "3deg" : 0;
});

var StyledMain = _styledComponents.default.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  width: 30px;\n  background: ", ";\n"])), function (p) {
  return p.theme.colorTicketBackground;
});

var StyledEnd = _styledComponents.default.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  width: 20px;\n"])));

var StyledEndBackground = _styledComponents.default.div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  flex: 1 1 auto;\n  background-color: ", ";\n  border-top-right-radius: ", ";\n  border-bottom-right-radius: ", "};\n"])), function (p) {
  return p.theme.colorTicketBackground;
}, function (p) {
  return p.isTop ? p.theme.borderRadius : 0;
}, function (p) {
  return !p.isTop ? p.theme.borderRadius : 0;
});

var StyledEndPath = _styledComponents.default.path(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  fill: ", ";\n"])), function (p) {
  return p.theme.colorTicketBackground;
});

var Wrapper = function Wrapper(_ref) {
  var isClaimed = _ref.isClaimed;
  return /*#__PURE__*/_react.default.createElement(StyledWrapper, {
    isClaimed: isClaimed
  }, /*#__PURE__*/_react.default.createElement(StyledMain, null), /*#__PURE__*/_react.default.createElement(StyledEnd, null, /*#__PURE__*/_react.default.createElement(StyledEndBackground, {
    isTop: true
  }), /*#__PURE__*/_react.default.createElement("svg", {
    width: "20",
    height: "40",
    viewBox: "0 0 20 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react.default.createElement(StyledEndPath, {
    d: "M20 0H0V20V40H20C8.95435 40 0 31.0457 0 20C0 8.95428 8.95435 0 20 0Z"
  })), /*#__PURE__*/_react.default.createElement(StyledEndBackground, null)));
};

var _default = Wrapper;
exports.default = _default;